module.exports = __webpack_public_path__ + "static/assets/ee4f8261355c8d3b6fd7228a386c62be.svg";